import { Component, Inject, OnInit } from '@angular/core';
import {
  FormGroup,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  ICliente,
  ICreateCliente,
  IIntegracionInfluxV1,
  IIntegracionInfluxV2,
  IListado,
  IQueryParam,
  ITipoDispositivo,
  TipoDispositivo,
} from 'modelos/src';
import { first } from 'rxjs/operators';
import { tipoDispositivos } from '../../../../environments/datos';
import { HelperService } from '../../../auxiliares/helper.service';
import { ListadosService } from '../../../auxiliares/listados.service';
import { ClientesService } from '../clientes.service';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-crear-editar-clientes',
  templateUrl: './crear-editar-clientes.component.html',
  styleUrls: ['./crear-editar-clientes.component.scss'],
})
export class CrearEditarClientesComponent implements OnInit {
  public loading = false;
  public form?: UntypedFormGroup;
  public title?: string;

  get formArrayIntegraciones() {
    return this.form?.get('integraciones') as UntypedFormArray;
  }

  public formCredenciales(i: number) {
    return this.formArrayIntegraciones
      .at(i)
      .get('credenciales') as UntypedFormGroup;
  }

  public formArrayCredenciales2(i: number) {
    return this.formArrayIntegraciones
      .at(i)
      .get('credenciales2') as UntypedFormArray;
  }

  public tipoDispositivos: TipoDispositivo[] = [];

  public tipoIntegraciones = ['INFLUXV1', 'INFLUXV2', 'HTTPS', 'MariaDB'];
  public metodosHttp = ['POST', 'PUT', 'PATCH', 'GET'];
  public ubicacionesCredenciales = ['Query Params', 'Headers', 'Body'];

  get formTwilio() {
    return this.form?.get('twilio') as FormGroup;
  }

  get formTemplatesWhatsapp() {
    return this.form?.get('twilio')?.get('templatesWhatsapp') as FormGroup;
  }

  get formTemplatesMail() {
    return this.form?.get('twilio')?.get('templatesMail') as FormGroup;
  }

  // Listado Continuo
  public tipoDispositivos$?: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ICliente,
    private fb: UntypedFormBuilder,
    private dialogRef: MatDialogRef<CrearEditarClientesComponent>,
    private helper: HelperService,
    private service: ClientesService,
    private listadosService: ListadosService
  ) {}

  private createForm(): void {
    this.title = this.data?._id ? 'Editar Cliente' : 'Crear Cliente';

    const imagenes = this.fb.group({
      logo: [this.data?.imagenes?.logo],
    });

    const formIntegraciones: UntypedFormGroup[] = [];
    if (this.data?.integraciones?.length) {
      for (const integracion of this.data?.integraciones) {
        let formCredenciales: UntypedFormGroup = this.fb.group({});
        if (integracion.tipoIntegracion === 'INFLUXV1') {
          const credenciales = integracion.credenciales as IIntegracionInfluxV1;
          formCredenciales = this.fb.group({
            host: [credenciales.host],
            port: [credenciales.port],
            protocol: [credenciales.protocol],
            username: [credenciales.username],
            password: [credenciales.password],
            dbName: [credenciales.dbName],
            measurement: [credenciales.measurement],
          });
        } else if (integracion.tipoIntegracion === 'INFLUXV2') {
          const credenciales = integracion.credenciales as IIntegracionInfluxV2;

          formCredenciales = this.fb.group({
            host: [credenciales.host],
            port: [credenciales.port],
            protocol: [credenciales.protocol],
            token: [credenciales.token],
            dbName: [credenciales.dbName],
            measurement: [credenciales.measurement],
            org: [credenciales.org],
          });
        }

        let formCredenciales2: UntypedFormGroup[] = [];
        if (integracion.credenciales2) {
          for (const credencial2 of integracion.credenciales2) {
            formCredenciales2.push(
              this.fb.group({
                key: [credencial2.key],
                value: [credencial2.value],
              })
            );
          }
        }

        formIntegraciones.push(
          this.fb.group({
            tipoDispositivo: [integracion.tipoDispositivo],
            tipoIntegracion: [integracion.tipoIntegracion],
            endpoint: [integracion.endpoint],
            method: [integracion.method],
            ubicacionCredenciales: [integracion.ubicacionCredenciales],
            credenciales: formCredenciales,
            credenciales2: this.fb.array(formCredenciales2),
          })
        );
      }
    }

    const twilio = this.fb.group({
      accSid: [this.data?.twilio?.accSid],
      authToken: [this.data?.twilio?.authToken],
      msgServiceSid: [this.data?.twilio?.msgServiceSid],
      phoneLlamada: [this.data?.twilio?.phoneLlamada],
      phoneSms: [this.data?.twilio?.phoneSms],
      phoneWhatsapp: [this.data?.twilio?.phoneWhatsapp],
      statusCallback: [this.data?.twilio?.statusCallback],
      templatesWhatsapp: this.fb.group({
        'Estado Bombeo': [
          this.data?.twilio?.templatesWhatsapp?.['Estado Bombeo'],
        ],
        'Estado Bombeo Motivo': [
          this.data?.twilio?.templatesWhatsapp?.['Estado Bombeo Motivo'],
        ],
        'Corte de Energía': [
          this.data?.twilio?.templatesWhatsapp?.['Corte de Energía'],
        ],
      }),

      //
      senderEmail: [this.data?.twilio?.senderEmail],
      senderName: [this.data?.twilio?.senderName],
      senderAddress: [this.data?.twilio?.senderAddress],
      senderCity: [this.data?.twilio?.senderCity],
      senderState: [this.data?.twilio?.senderState],
      senderZip: [this.data?.twilio?.senderZip],
      sendGridApiKey: [this.data?.twilio?.sendGridApiKey],
      templatesMail: this.fb.group({
        // TemplatesMail`
        'Nuevo usuario': [this.data?.twilio?.templatesMail?.['Nuevo usuario']],
        'Reset de contraseña': [
          this.data?.twilio?.templatesMail?.['Reset de contraseña'],
        ],
        'Cambio de contraseña': [
          this.data?.twilio?.templatesMail?.['Cambio de contraseña'],
        ],
      }),
    });

    this.form = this.fb.group({
      nombre: [this.data?.nombre, Validators.required],
      tiposDispositivo: [this.data?.tiposDispositivo],
      imagenes,
      integraciones: this.fb.array(formIntegraciones),
      twilio,
    });
  }

  public close(): void {
    this.dialogRef.close();
  }

  //

  private getData() {
    const data: ICreateCliente = this.form?.value;
    return data;
  }

  public async onSubmit(): Promise<void> {
    this.loading = true;
    try {
      const data = this.getData();
      if (this.data?._id) {
        await this.service
          .editar(this.data._id, data)
          .pipe(first())
          .toPromise();
        this.helper.notifSuccess('Editado correctamente');
      } else {
        await this.service.crear(data).pipe(first()).toPromise();
        this.helper.notifSuccess('Creado correctamente');
      }
      this.dialogRef.close(true);
    } catch (err) {
      console.error(err);
      this.helper.notifError(err);
    }
    this.loading = false;
  }

  //

  //

  public cambioTipoIntegracion(i: number) {
    const tipoIntegracion = this.formArrayIntegraciones
      .at(i)
      .get('tipoIntegracion')?.value;

    let formCredenciales: UntypedFormGroup = this.fb.group({});

    if (tipoIntegracion === 'INFLUXV1') {
      formCredenciales = this.fb.group({
        host: [null, Validators.required],
        port: [null, Validators.required],
        protocol: [null, Validators.required],
        username: [null, Validators.required],
        password: [null, Validators.required],
        dbName: [null, Validators.required],
        measurement: [null, Validators.required],
      });
    } else if (tipoIntegracion === 'INFLUXV2') {
      formCredenciales = this.fb.group({
        host: [null, Validators.required],
        port: [null, Validators.required],
        protocol: [null, Validators.required],
        token: [null, Validators.required],
        dbName: [null, Validators.required],
        measurement: [null, Validators.required],
        org: [null, Validators.required],
      });
    }

    (this.formArrayIntegraciones.at(i) as UntypedFormGroup)?.setControl(
      'credenciales',
      formCredenciales
    );
  }

  public agregarIntegracion() {
    this.formArrayIntegraciones.push(
      this.fb.group({
        tipoDispositivo: [null],
        tipoIntegracion: [null],
        endpoint: [null],
        ubicacionCredenciales: [null],
        method: [null],
        // credenciales: formCredenciales,
        credenciales2: this.fb.array([
          this.fb.group({
            key: [null],
            value: [null],
          }),
        ]),
      })
    );
  }

  public eliminarIntegracion(i: number) {
    this.formArrayIntegraciones.removeAt(i);
  }

  public agregarCredenciales2(i: number) {
    this.formArrayCredenciales2(i).push(
      this.fb.group({
        key: [null, Validators.required],
        value: [null, Validators.required],
      })
    );
  }

  public eliminarCredenciales2(i: number, j: number) {
    this.formArrayCredenciales2(i).removeAt(j);
  }

  //

  private async listarTipoDispositivos(): Promise<void> {
    const query: IQueryParam = {
      sort: 'nombre',
    };
    this.tipoDispositivos$?.unsubscribe();
    this.tipoDispositivos$ = this.listadosService
      .subscribe<IListado<ITipoDispositivo>>('tipoDispositivos', query)
      .subscribe((data) => {
        this.tipoDispositivos = data.datos.map((e) => e.nombre);
        console.log(`listado de tipoDispositivos`, data);
      });
    await this.listadosService.getLastValue('tipoDispositivos', query);
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.createForm();
    await this.listarTipoDispositivos();
    this.loading = false;
  }
}
